import { getDropdownOptionsData } from "./getDropdownOptionsData";
import { FilterVisitFlags } from "../../utils/FilterVisitFlags";

export function getDropdownsData(categories, originalData, location) {
  let arr = [];
  categories.forEach((cate) => {
    if (cate.isStatic === true) {
      arr.push(cate);
    } else {
      const item = {
        name: cate.name,
        optionsList: getDropdownOptionsData(originalData, {
          val: cate.value ? cate.value : cate.label,
          lab: cate.label,
        }),
        valueAddress: cate.value ? cate.value : cate.label,
         unsort: cate.unsort
      };
      arr.push(item);
    }
  });
  // Add extra filter category for the visit page
  const currentUrl = location.pathname;
  if (
    currentUrl === "/complaint/visit-all" ||
    currentUrl === "/complaint/visit-pending"
  ) {
    arr.push(FilterVisitFlags);
  }
  return arr;
}
